import { FC, SVGProps } from 'react'

export const IconDocumentAdd: FC<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  return (
    <svg
      width="33"
      height="34"
      viewBox="0 0 33 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter={`url(#${filter0})`}>
        <path
          d="M21.6316 16.8996V14.4658C21.6316 13.998 21.4675 13.5449 21.168 13.1855L18.2839 9.72451C17.9039 9.26853 17.341 9.00488 16.7475 9.00488H15.3158H13C10.7909 9.00488 9 10.7957 9 13.0049V20.7944C9 23.0035 10.7909 24.7944 13 24.7944H16.1053"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M19.2632 22.4258H24"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6328 20.0576L21.6328 24.7944"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.6836 9.39941V11.7415C17.6836 12.8461 18.579 13.7415 19.6836 13.7415H21.2362"
          stroke="#C8F252"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="0.398438"
          y="0.404785"
          width="32.2031"
          height="32.9897"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6773_116003"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6773_116003"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
